import { render } from "./addGoods.vue?vue&type=template&id=18236c6e&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"

import "./addGoods.vue?vue&type=style&index=0&id=18236c6e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18236c6e"]])

export default __exports__